import React from "react";

export default function ITSM(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Use of Information Technology and Social Media
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Slum Soccer aims to ensure that children are protected from
            potential risks associated with the use of information technology
            and social media. Use of IT and social media should be done keeping
            paramount that children are not put in danger or made vulnerable to
            exploitation. For the same the following guidelines shall apply:
          </span>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Staff shall take prior consent of parents/ guardians to take
                photographs of children for use of promoting Slum Soccer’s work
                through reports, social media posts, and other forms of
                promotion.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Staff shall not engage in any form of online communication with
                children that is not related to their work with Slum Soccer.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Any online communication with children should be conducted
                through official Slum Soccer channels and should be transparent
                and open to scrutiny.
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Some people use sporting events as an opportunity to take
            inappropriate photographs or film footage of young and disabled
            sports people in vulnerable positions. All SS staff shall be
            vigilant of such eventuality and shall report any such concerns to
            the SS Child Protection Officer.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Videoing as a coaching aid
          </h2>
          <span className="text-gray-700 block mb-1">
            Making videos as a legitimate coaching aid shall be done only after
            obtaining the written consent of the parents/ carers of the children
            featuring in the video.
          </span>
        </div>
      </div>
    </div>
  );
}
